import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import companyInfo from '../data/companyInfo.json';
import '../styles/ContactUs.css';

import heroImage from '../assets/images/aboutHero.png';


const ContactUs = ({ onNavigate }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic can be added here
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="contact-us">
      <Header onNavigate={onNavigate} />

      {/* PAGE TITLE */}
      <section className="page-title" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="container">
          <h1>Contact Us</h1>
          <p>Get in Touch with MaxInfra</p>
        </div>
      </section>

      {/* CONTACT INFO & FORM */}
      <section className="contact-section">
        <div className="container contact-container">
          
          {/* LEFT SIDE - CONTACT INFO */}
          <div className="contact-info">
            <h2>Contact Information</h2>
            
            <div className="info-card">
              <div className="info-icon"></div>
              <h3>Office Location</h3>
              <p>
                {companyInfo.address}
              </p>
            </div>

            <div className="info-card">
              <div className="info-icon"></div>
              <h3>Phone</h3>
              <p>
                <a href={`tel:${companyInfo.phone}`}>
                  {companyInfo.phone}
                </a>
              </p>
              <p>
                <a href="tel:+918121352777">
                  +91 8121352777
                </a>
              </p>
            </div>

            <div className="info-card">
              <div className="info-icon"></div>
              <h3>Email</h3>
              <p>
                <a href={`mailto:${companyInfo.email}`}>
                  {companyInfo.email}
                </a>
              </p>
            </div>

            <div className="info-card">
              <div className="info-icon"></div>
              <h3>Working Hours</h3>
              <p>
                <strong>Monday - Saturday</strong><br />
                9:30 AM - 6:00 PM
              </p>
              <p>
                <strong>Sunday</strong><br />
                Closed
              </p>
            </div>
          </div>

          {/* RIGHT SIDE - CONTACT FORM */}
          <div className="contact-form">
            <h2>Send us a Message</h2>
            <p>We'd love to hear from you. Fill the form below and we'll get back to you soon.</p>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Your Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Your Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your email address"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="Enter subject"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Enter your message"
                />
              </div>

              <button type="submit" className="btn-primary">
                Send Message
              </button>
            </form>
          </div>

        </div>
      </section>

      {/* MAP SECTION */}
      <section className="map-section">
        <div className="container">
          <h2>Find Us on Map</h2>
          <div className="map-container">
            <iframe
              width="100%"
              height="400"
              frameBorder="0"
              style={{ border: 0 }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.9649340635486!2d78.3656!3d17.4425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e8f0000001%3A0x1234567890!2sAyyappa%20Society%20Madhapur%20Hyderabad!5e0!3m2!1sen!2sin!4v1234567890"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactUs;